import { Pipe, type PipeTransform } from '@angular/core';
import { CustomerType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { ZPLateFormatPipe } from '../plate-format.pipe';

@Pipe({
    name: 'zCustomerSubjects'
})
export class CustomerSubjectsPipe implements PipeTransform {
    transform(customer: CustomerType | undefined) {
        return customer?.Subjects?.map((customerToEntitySubject) => {
            return new ZPLateFormatPipe().transform(
                customerToEntitySubject.Subject?.PlateNo,
                customerToEntitySubject.Subject?.IsForeign,
                customerToEntitySubject.Subject
            );
        })?.join(', ');
    }
}
